import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { getAuth, isLoggedIn, logoutAndClearAuth } from "../auth";
import { usePermission } from "./Auth/PermissionContext";
import { PermissionKeys } from "../permissions";

const menuItems = [
  { to: "/gps-monitor", label: "实时监控", permission: PermissionKeys.MonitorView },
  { to: "/track-playback", label: "轨迹回放", permission: PermissionKeys.TrackView },
  { to: "/devices", label: "设备管理", permission: PermissionKeys.DeviceView, roles: ["Admin"] },
  { to: "/users", label: "用户管理", permission: PermissionKeys.UserView },
  { to: "/employees", label: "员工管理", permission: PermissionKeys.EmployeeView },
  { to: "/groups", label: "车辆分组", permission: PermissionKeys.GroupView },
  { to: "/connection-logs", label: "连接日志", permission: PermissionKeys.ConnectionLogView },
  { to: "/alarm-logs", label: "报警日志", permission: PermissionKeys.AlarmLogView },
  { to: "/system-operation-logs", label: "系统操作日志", permission: PermissionKeys.SystemOpLogView },
  { to: "/permissions", label: "权限管理", permission: PermissionKeys.PermissionManage },
  { to: "/ggg-manager", label: "GGG 管理", permission: PermissionKeys.GggManagerView }
];

function LayoutInner({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const loggedIn = isLoggedIn();
  const auth = getAuth();
  const isLoginPage = location.pathname === "/login";
  const { can } = usePermission();

  if (!loggedIn || isLoginPage) {
    return <>{children}</>;
  }

  const role = auth?.role || "";
  const visibleMenuItems = menuItems.filter((item) =>
    can(item.permission) && (!item.roles || item.roles.some((x) => x.toLowerCase() === role.toLowerCase()))
  );

  return (
    <div className="admin-shell">
      <header className="admin-header">
        <div className="admin-brand">MycGpsV2 后台</div>
        <div className="admin-user">
          <span className="admin-user-name">{auth?.realName || auth?.loginName || "用户"}</span>
          <button
            type="button"
            className="admin-logout-btn"
            onClick={() => {
              logoutAndClearAuth().finally(() => navigate("/login"));
            }}
          >
            退出登录
          </button>
        </div>
      </header>

      <div className="admin-main">
        <aside className="admin-sider">
          <nav className="admin-menu">
            {visibleMenuItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `admin-menu-item${isActive ? " active" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        <main className="admin-content">{children}</main>
      </div>
    </div>
  );
}

export function Layout(props) {
  return <LayoutInner>{props.children}</LayoutInner>;
}
